// extracted by mini-css-extract-plugin
export var banner = "_r0-0";
export var settingRow = "_r0-2";
export var titleIcon = "_r0-1";